(function () {
  var viewport = document.querySelector('[data-bd-ateam]');
  if (!viewport) return;

  var track = viewport.querySelector('[data-bd-ateam-track]');
  if (!track) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pxPerFrame = reduceMotion ? 0 : 0.6;

  var posX = 0;
  var isPaused = false;
  var isDragging = false;
  var touchActive = false;
  var hasDragged = false;
  var dragStartX = 0;
  var dragStartPos = 0;

  function singleSetWidth() {
    return track.scrollWidth / 3;
  }

  function wrap() {
    var setWidth = singleSetWidth();
    if (setWidth <= 0) return;
    if (posX <= -setWidth) posX += setWidth;
    if (posX > 0) posX -= setWidth;
  }

  function render() {
    track.style.transform = 'translateX(' + posX + 'px)';
  }

  function tick() {
    if (!isDragging && !touchActive && !isPaused) {
      posX -= pxPerFrame;
    }
    wrap();
    render();
    requestAnimationFrame(tick);
  }

  requestAnimationFrame(function () {
    posX = -singleSetWidth();
    render();
    requestAnimationFrame(tick);
  });

  /* Auto-scroll + pause on hover */
  viewport.addEventListener('mouseenter', function () { isPaused = true; });
  viewport.addEventListener('mouseleave', function () { isPaused = false; });

  /* Mouse click-and-drag */
  viewport.addEventListener('mousedown', function (e) {
    isDragging = true;
    hasDragged = false;
    dragStartX = e.clientX;
    dragStartPos = posX;
    viewport.classList.add('is-dragging');
  });
  window.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    var delta = e.clientX - dragStartX;
    if (Math.abs(delta) > 3) hasDragged = true;
    posX = dragStartPos + delta;
  });
  window.addEventListener('mouseup', function () {
    if (!isDragging) return;
    isDragging = false;
    viewport.classList.remove('is-dragging');
  });
  viewport.addEventListener(
    'click',
    function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );

  /* Touch / finger swipe */
  viewport.addEventListener(
    'touchstart',
    function (e) {
      touchActive = true;
      dragStartX = e.touches[0].clientX;
      dragStartPos = posX;
    },
    { passive: true }
  );
  window.addEventListener(
    'touchmove',
    function (e) {
      if (!touchActive) return;
      var delta = e.touches[0].clientX - dragStartX;
      posX = dragStartPos + delta;
    },
    { passive: true }
  );
  window.addEventListener('touchend', function () {
    touchActive = false;
  });

  /* Touchpad two-finger horizontal swipe */
  viewport.addEventListener(
    'wheel',
    function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      posX -= e.deltaX;
    },
    { passive: false }
  );
})();